<template>
    <ElevatedCard class="container-widget" :widthType="WidthType.third">
        <HeaderWidget
            :title="widget.libelle"
            :subtitle="$t('outPreventiveWidget.subtitle')"
            :iconUrl="loadIcon"
            :mode-edition='true'
            @filtre='filtre'
            @dupliquer='dupliquer'
            @suppression='suppression'
        />
        <div>
            <span v-if='widget.sites == null || widget.sites.length > 1' class='site-widget'>{{$t('multisites')}}</span>
            <span v-else v-for='site in widget.sites' :key='site.id' class='site-widget'>
                {{site.description}}
                <span v-if='site.id !== widget.sites[widget.sites.length - 1].id'>, </span>
            </span>
        </div>
        <div class="container-tiles">
            <Tile
                class="tile"
                :value="5"
                color="--edition-clair"
                :titleNotBold="$tc('outPreventiveWidget.intervention', getPreventiveOutData.nbARealiser)"
                :titleInBold="$t('outPreventiveWidget.nbARealiser')"
                :isLoading="false"
            />
            <Tile
                class="tile"
                :value="3"
                color="--edition-medium"
                :titleNotBold="$tc('outPreventiveWidget.intervention', getPreventiveOutData.nbEnCours)"
                :titleInBold="$t('outPreventiveWidget.nbEnCours')"
                :isLoading="false"
            />
            <Tile
                class="tile"
                :value="5"
                color="--edition-fonce"
                :titleNotBold="$tc('outPreventiveWidget.intervention', getPreventiveOutData.nbRealisees)"
                :titleInBold="$tc('outPreventiveWidget.nbRealisees', getPreventiveOutData.nbRealisees)"
                :isLoading="false"
            />
        </div>
    </ElevatedCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import ElevatedCard, { WidthType } from '@/components/ui-components/ElevatedCard.vue';
import HeaderWidget from '@/components/ui-components/HeaderWidget.vue';
import Tile from '@/components/ui-components/Tile.vue';
import { EtatsTravaux } from '@/models/InterventionNonPreventive';
import { Widget } from '@/models/Widget';

export default defineComponent({
    name: 'EditionPreventiveOut',
    components: { ElevatedCard, Tile, HeaderWidget },
    props: {
        widget:{ type: Object as PropType<Widget>, required: true },
    },
    setup() {
        return {
            WidthType,
            EtatsTravaux,
        };
    },
    computed: {
        isLoading() {
            return this.$store.state.homeState.widgetTravaux.isLoading;
        },
        getPreventiveOutData() {
            return this.$store.getters.getPreventiveOut;
        },
        loadIcon() {
            return require('@/assets/img/menu/handyman.png');
        },
    },
    methods: {
        filtre() {
            this.$emit('filtre');
        },
        dupliquer() {
            this.$emit('dupliquer');
        },
        suppression() {
            this.$emit('suppression');
        },
    },
});
</script>

<style scoped>
.container-tiles {
    padding: 10px 10px 8%;
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-grow: 1;
    gap: 25px;
    align-items: center;
    height: 180px;
    width: 86%;
    margin-left: auto;
    margin-right: auto;
}
@media screen and (max-width: 1600px) {
    .container-tiles {
        gap: 15px;
        width: 95%;
    }
}
.container-widget {
    display: flex;
    flex-direction: column;
    background-color: var(--white);
}
.tile {
    margin: 5px 0;
    cursor: pointer;
    height: 120px;
    max-height: 20vh !important;
}
</style>
